<template>
  <div
    class="skagen-consent-details"
    :class="{ 'skagen-consent-overlay': !blockViewMode }"
  >
    <div
      class="container skagen-consent-container"
      :class="{ 'container--primary': blockViewMode }"
    >
      <div class="page-header">
        <h2>{{ consentTexts.heading }}</h2>
      </div>
      <div class="skagen-purpose-holder">
        <div class="row">
          <div class="col-sm-8 col-xs-12">
            <div class="checkbox checkbox-approved-by">
              <input
                :id="checkboxUsefulId"
                type="checkbox"
                v-model="consent.useful"
                @click="saveDisabled = false"
              />
              <label :for="checkboxUsefulId">
                <div class="skagen-header">
                  {{ consentTexts.headingUseful }}
                </div>
                <div class="skagen-text">{{ consentTexts.textUseful }}</div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="skagen-purpose-holder">
        <div class="row">
          <div class="col-sm-8 col-xs-12">
            <div class="checkbox checkbox-approved-by">
              <input
                :id="checkboxAnalyticsId"
                type="checkbox"
                v-model="consent.analytics"
                @click="saveDisabled = false"
              />
              <label :for="checkboxAnalyticsId">
                <div class="skagen-header">
                  {{ consentTexts.headingAnalytics }}
                </div>
                <div class="skagen-text">{{ consentTexts.textAnalytics }}</div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="skagen-purpose-holder">
        <div class="row">
          <div class="col-sm-8 col-xs-12">
            <div class="checkbox checkbox-approved-by">
              <input
                :id="checkboxMarketingId"
                type="checkbox"
                v-model="consent.marketing"
                @click="saveDisabled = false"
              />
              <label :for="checkboxMarketingId">
                <div class="skagen-header">
                  {{ consentTexts.headingMarketing }}
                </div>
                <div class="skagen-text">{{ consentTexts.textMarketing }}</div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="skagen-purpose-holder">
        <div class="row">
          <div class="col-sm-8 col-xs-12">
            <div class="checkbox checkbox-approved-by">
              <input
                :id="checkboxBasicId"
                type="checkbox"
                v-model="consent.basic"
                disabled="true"
              />
              <label :for="checkboxBasicId">
                <div class="skagen-header">{{ consentTexts.headingBasic }}</div>
                <div class="skagen-text">{{ consentTexts.textBasic }}</div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="skagen-purpose-buttons">
        <button
          class="btn btn-primary"
          v-on:click="save()"
          :disabled="saveDisabled"
        >
          {{ consentTexts.detailButtonSave }}
        </button>
        <button class="btn btn-link" v-on:click="back()" v-if="!blockViewMode">
          {{ consentTexts.detailButtonBack }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'DetailsConsent',
  props: {
    blockViewMode: { type: Boolean },
    consentTexts: { type: Object },
    consentData: { type: Object },
  },
  data() {
    return {
      uuid: '',
      saveDisabled: true,
      consent: {
        basic: true,
        useful: false,
        analytics: false,
        marketing: false,
      },
    };
  },
  created() {
    this.uuid = uuidv4();
    this.consent.basic = this.consentData.basic;
    this.consent.useful = this.consentData.useful;
    this.consent.analytics = this.consentData.analytics;
    this.consent.marketing = this.consentData.marketing;
    // We want save button initial enabled in this mode (must be possible to create / save cookie without doing a change)
    if (!this.blockViewMode) {
      this.saveDisabled = false;
    }
  },
  computed: {
    checkboxBasicId() {
      return 'consent-checkbox-basic' + this.uuid;
    },
    checkboxUsefulId() {
      return 'consent-checkbox-useful' + this.uuid;
    },
    checkboxAnalyticsId() {
      return 'consent-checkbox-analytics' + this.uuid;
    },
    checkboxMarketingId() {
      return 'consent-checkbox-marketing' + this.uuid;
    },
  },
  methods: {
    back() {
      this.$emit('consent:showGeneral');
    },
    save() {
      this.$emit('consent:acceptCustom', this.consent);
      this.saveDisabled = true;
    },
  },
};
</script>
<style>
.skagen-consent-container .skagen-purpose-holder {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.skagen-consent-container .skagen-purpose-holder .skagen-header {
  font-weight: bold;
}

.skagen-consent-container .skagen-purpose-holder .skagen-text {
  width: 100%;
  font-size: 16px;
}

.skagen-consent-container .skagen-purpose-holder .checkbox label {
  padding-left: 26px;
}

.skagen-consent-container .skagen-purpose-holder .checkbox label::before {
  width: 24px;
  height: 24px;
  top: 4px;
  margin-left: -18px;
}

.skagen-consent-container .skagen-purpose-holder .checkbox label::after {
  width: 24px;
  height: 24px;
  font-size: 20px;
}

.skagen-consent-container
  .skagen-purpose-holder
  .checkbox-approved-by
  input[type='checkbox']:checked
  + label::before {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.skagen-consent-container
  .skagen-purpose-holder
  .checkbox-approved-by
  input[type='checkbox']:checked
  + label::after {
  color: #fff;
  top: 1px;
}

.skagen-consent-container .skagen-purpose-buttons {
  margin-top: 30px;
}
</style>
